import request from "util/request";
import { hardNavigateToUnsafe } from "util/navigation";

export function signIntoDigicert() {
  const url = encodeURI(`digicert/authorization_url?redirect_url=${window.location.href}`);
  request("get", url, {}).then((json) => hardNavigateToUnsafe(json.url));
}
